"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCTA = void 0;
var _useUserSessionStatus2 = require("../user/useUserSessionStatus");
var _constants = require("../../utils/constants");
var _reactRedux = require("react-redux");
var _widgetSelectors = require("../../store/widget/widgetSelectors");
var _react = require("react");
var _services = require("../../services");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useCTA = function useCTA() {
  var _useUserSessionStatus = (0, _useUserSessionStatus2.useUserSessionStatus)(),
    userSessionJourneyStatus = _useUserSessionStatus.userSessionJourneyStatus;
  var CTASettings = (0, _reactRedux.useSelector)(_widgetSelectors.selectCTASettings);
  var showCTADelay = CTASettings.showRibbonDelay * 1000;
  var showExtendedCTADelay = CTASettings.showPopUp * 1000;
  var appearance = CTASettings.Appearance;
  var content = {
    ribbonText: _services.locale.localeString('EntryPoint.RibbonText'),
    floatingButtonText: _services.locale.localeString('EntryPoint.FloatingButtonText'),
    popupTitle: _services.locale.localeString('EntryPoint.PopUpTitle'),
    popupText: '',
    popupCancelButtonText: _services.locale.localeString('EntryPoint.CancelButtonText'),
    popupOkButtonText: '',
    inFlowButtonText: _services.locale.localeString('EntryPoint.InflowButtonText')
  };
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showExtendedCTA = _useState2[0],
    setShowExtendedCTA = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showCTA = _useState4[0],
    setShowCTA = _useState4[1];
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      setShowCTA(true);
    }, showCTADelay);
  }, []);
  (0, _react.useEffect)(function () {
    if (showCTA === true) {
      var openExtendedFloating = setTimeout(function () {
        setShowExtendedCTA(true);
      }, showExtendedCTADelay);
      var mousedownListener = function mousedownListener() {
        clearTimeout(openExtendedFloating);
      };
      document.addEventListener('mousedown', mousedownListener);
      return function () {
        document.removeEventListener('mousedown', mousedownListener);
      };
    }
  }, [showCTA]);
  switch (userSessionJourneyStatus) {
    case _constants.USER_SESSION_JOURNEY_STATUS.NEW_USER:
    case _constants.USER_SESSION_JOURNEY_STATUS.RETURNING_USER_START:
      {
        content.popupText = _services.locale.localeString('EntryPoint.NewUserText');
        content.popupOkButtonText = _services.locale.localeString('EntryPoint.NewUserButtonText');
        break;
      }
    case _constants.USER_SESSION_JOURNEY_STATUS.RETURNING_USER_QUESTIONNAIRE:
      {
        content.popupText = _services.locale.localeString('EntryPoint.ReturningUserText');
        content.popupOkButtonText = _services.locale.localeString('EntryPoint.ReturningUserButtonText');
        break;
      }
    case _constants.USER_SESSION_JOURNEY_STATUS.RETURNING_USER_RECOMMENDATION:
      {
        content.ribbonText = _services.locale.localeString('EntryPoint.RecommendationRibbonText');
        content.popupTitle = _services.locale.localeString('EntryPoint.RecommendationTitle');
        content.popupText = _services.locale.localeString('EntryPoint.RecommendationPopUp');
        content.popupOkButtonText = _services.locale.localeString('EntryPoint.RecommendationPopUpOkButton');
        break;
      }
  }
  return {
    content: content,
    appearance: appearance,
    showCTA: showCTA,
    showExtendedCTA: showExtendedCTA
  };
};
exports.useCTA = useCTA;